
// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
	// var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
	$('a[href^="#"]').click(function () {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		if (target.length > 0) {
			var position = target.offset().top - headerHeight;
			$("html, body").animate({ scrollTop: position }, 550, "swing");
			return false;
		}
	});
})

// ブログサムネイル 中心でトリミング // Blog thumbnail Crop at center
jQuery(function ($) {
	if ($('.obj_image').length > 0) {
		objectFitImages('.obj_image');
	}
});


// ページトップボタンの表示 // Display the page top button
jQuery(function ($) {
	if ($('#pageup').length > 0) {
		var topBtn = $('#pageup');
		topBtn.css("display", "none");

		$(window).scroll(function () {
			if ($(this).scrollTop() > 100) {
				topBtn.fadeIn();
			} else {
				topBtn.fadeOut();
			}
		});
		//スクロールしてトップ // scroll to the top
		topBtn.click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 500);
			return false;
		});
	}
});


// ヘッダーの固定エフェクト // Fixed header effect
jQuery(function ($) {
	var $stick = $('.js-sticky');
	$(window).scroll(function () {
		if ($(window).scrollTop() > 10) {
			$stick.addClass('fixed');
		} else {
			$stick.removeClass('fixed');
		}
	});
});




// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function ($) {

	if ($('.js-image-switch').length > 0) {

		var $elem = $('.js-image-switch');
		var sp = '_sp.';
		var pc = '_pc.';
		// 画像を切り替えるウィンドウサイズ // Window size to switch images
		var replaceWidth = 768;

		function imageSwitch() {
			var windowWidth = parseInt($(window).width());
			$elem.each(function () {
				var $this = $(this);
				if (windowWidth >= replaceWidth) {
					$this.attr('src', $this.attr('src').replace(sp, pc));
				} else {
					$this.attr('src', $this.attr('src').replace(pc, sp));
				}
			});
		}
		imageSwitch();

		var resizeTimer;
		$(window).on('resize', function () {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function () {
				imageSwitch();
			}, 200);
		});
	}
});


// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
	if ($('.js-accordion').length > 0) {
		$(".js-accordion-head").click(function () {
			$(this).next(".js-accordion-content").slideToggle();
			$(this).toggleClass("open");
		});
	}
});

// ドロワーメニュー // Drawer menu
jQuery(function ($) {
	if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				$('nav').addClass('is_open');
				$('nav').removeClass('is_close');
				$('header .js-toggle').on('click', function(event){
					toggleMenu($(this),event);
				})
			} else {
				$('nav').removeClass('is_open');
				$('nav').addClass('is_close');

				$('header .js-toggle').off()
				$('header .js-toggle').next("ul").slideUp();
				$('header .js-toggle').removeClass("open");
			}
		});

		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			$('nav').removeClass('is_open');
			$('nav').removeClass('js-toggle-action');
			$('nav').addClass('is_close');
			$('header .js-toggle').off()
			$('header .js-toggle').next("ul").slideUp();
			$('header .js-toggle').removeClass("open");
		});

		// エリア内リンク用 // For links within an area
		// $('nav a').on('click', function () {
		// 	// if (window.innerWidth <= 768) {
		// 	if ($('#toggle:visible').length > 0) {
		// 		$('#toggle').click();
		// 	}
		// });
	}

});


// facebookプラグインリサイズ処理 // facebook plugin resizing process
// jQuery(function($) {

// 	if ( $('#pageplugin').length > 0 ) {

// 		var windowWidth = $(window).width();
// 		var htmlStr = $('#pageplugin').html();
// 		var timer = null;
// 		$(window).on('resize',function() {
// 			var resizedWidth = $(window).width();
// 			if(windowWidth != resizedWidth && resizedWidth < 500) {
// 				clearTimeout(timer);
// 				timer = setTimeout(function() {
// 					$('#pageplugin').html(htmlStr);
// 					window.FB.XFBML.parse();
// 			   		//window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
// 					var windowWidth = $(window).width();
// 				}, 500);
// 			}
// 		});
// 	}
// });


// change color placeholder select
jQuery(function ($) {
	if (jQuery('select').length) {
		jQuery('select').each(function () {
			if ($(this).val() === "" || $(this).val() === null) {
				$(this).addClass('placeholder');
			} else {
				$(this).removeClass('placeholder');
			}
		});

		jQuery('select').on('change', function (e) {
			if ($(this).val() === "" || $(this).val() === null) {
				$(this).addClass('placeholder');
			} else {
				$(this).removeClass('placeholder');
			}
		});
	}
});

// fixed pageUP
jQuery(function ($) {
	$(window).bind("ready resize scroll", function () {
		var pageTop = $('#pageup');
		var footer = $('.l-footer');

		var x = $(window).scrollTop() + $(window).height();
		var y = footer.offset().top;

		if (x >= y + 40) {
			pageTop.removeClass('fixed').addClass('abso');
		}
		else {
			pageTop.removeClass('abso').addClass('fixed');
		}
	});

})


jQuery(function ($) {
	if ($('.js-toggle').length > 0 && $(window).width() < 769) {
		$('footer .js-toggle').on('click', function(event){
			toggleMenu($(this),event);
		})
	}
});

function toggleMenu(el,event){
	event.preventDefault();
	let $ = jQuery;
	console.log(el)
	$(el).next("ul").slideToggle();
	$(el).toggleClass("open");
	return false;
}


jQuery(function ($) {

	$('select[name="highway"]').change(function () {

		var countyName = $('select[name="highway"] option:selected').attr("class");
		console.log(countyName);

		var count = $('select[name="interchange"]').children().length;

		for (var i = 0; i < count; i++) {

			var interchange = $('select[name="interchange"] option:eq(' + i + ')');

			if (interchange.attr("class") === countyName) {
				interchange.show();
			} else {
				if (interchange.attr("class") === "msg") {
					interchange.show();
					interchange.prop('selected', true);
				} else {
					interchange.hide();
				}
			}
		}
	})
})